"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CustomIconOrImage = _interopRequireDefault(require("../shared/CustomIconOrImage"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _services = require("../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SuccessDiv = (0, _styledComponents.default)('div')`
  display: flex;
  justify-content: center;
`;
const SuccessWrapperDiv = (0, _styledComponents.default)('div')`
  border: 1px solid #bebebe;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
const SuccessHeaderDiv = (0, _styledComponents.default)('div')`
  text-align: center;
  padding-top: 16px;
  width: 100%;
  display: flex;
  justify-content: center;
`;
const SuccessContentDiv = (0, _styledComponents.default)('div')`
  display: flex;
  flex-direction: column;
  padding-top: 6px;
  padding-bottom: 16px;
  gap: 6;
`;
const SuccessTextDiv = (0, _styledComponents.default)('div')`
  font-size: 18px;
  text-align: center;
  font-weight: bold;
`;
const SuccessSubTextDiv = (0, _styledComponents.default)('div')`
  font-size: 18px;
  text-align: center;
`;
const DEFAULT_SUCCESS_ICON = {
  src: '/assets/ws10/icons/default/rating-check.svg',
  width: '24',
  height: '24'
};
const SuccessMessage = () => {
  const successText = _services.locale.localeString('Recommendation.StarRatingInput.successText');
  const successSubText = _services.locale.localeString('Recommendation.StarRatingInput.successSubText');
  const {
    src,
    width,
    height
  } = (0, _useLocalTheme.default)('rating.successIcon', DEFAULT_SUCCESS_ICON);
  return /*#__PURE__*/_react.default.createElement(SuccessDiv, {
    "data-testid": "star-rating-input-success"
  }, /*#__PURE__*/_react.default.createElement(SuccessWrapperDiv, null, /*#__PURE__*/_react.default.createElement(SuccessHeaderDiv, null, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    iconWidth: width,
    iconHeight: height,
    src: {
      sm: src,
      md: src,
      lg: src
    }
  })), /*#__PURE__*/_react.default.createElement(SuccessContentDiv, null, /*#__PURE__*/_react.default.createElement(SuccessTextDiv, null, successText), successSubText && /*#__PURE__*/_react.default.createElement(SuccessSubTextDiv, null, successSubText))));
};
var _default = SuccessMessage;
exports.default = _default;